// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vgeod","buttons":"styles_buttons__1W2TE"};